__turbopack_context__.v({
  "dateContainer": "Honw9G_dateContainer",
  "disabled": "Honw9G_disabled",
  "highlighted": "Honw9G_highlighted",
  "outsideOfMonth": "Honw9G_outsideOfMonth",
  "selected": "Honw9G_selected",
  "today": "Honw9G_today",
});
